import * as Logger from 'loglevel'

export const fetchMediaZipInfo = async (objectId, accessToken) => {
  const token = accessToken
  const url = `api/newsitem${objectId ? `/${objectId}` : ''}?download=true`
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  if (response.ok) {
    const contentDisposition = response.headers
      .get('content-disposition')
      .replace(/"/g, '')
    Logger.debug(contentDisposition)
    const blob = await response.blob()
    const filenameRegexGroups = contentDisposition.match(
      /(?:filename=)(.*)(?=; filename)/
    )
    /// /(?:filename=)(.*)(?=\.zip;)/
    /// (?<=filename=)(.*)(?=\.zip;)/.exec(contentDisposition); positive lookbehind (?<=) isn't supported in safari
    let filename = ''
    Logger.debug(filenameRegexGroups)
    if (!!filenameRegexGroups && filenameRegexGroups.length > 1) {
      filename = filenameRegexGroups[1]
    }
    Logger.debug(filename)
    return { name: filename, url: URL.createObjectURL(blob) }
  } else {
    var errorDetails = await response.json()
    return { error: errorDetails.error }
  }
}
